import React, { useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { ArrowCircleRightRounded } from "@mui/icons-material";
import axios from "axios";
import SubscriptionAlertModal from "../modals/SubscriptionAlertModal";
import { AppContext } from "../../../context";
import { isAusDomain } from "../clinicalNotesClinicalRoute/lib/utils";

const getBenefitEnums = () => ({
  clinical_notes: "Clinical Notes",
  letter_templates: "Letter Templates",
  ask_sam_interactions: `${isAusDomain() ? "Ask Sam" : "United We Care"} Interactions`,
  download_clinical_notes: "Download Clinical Notes",
  education_materials: "Education Materials",
  customer_support: "Customer Support",
});

// Map API response to UI plan structure
function mapApiPlansToUi(apiData, country = null) {
  const currencySymbol = country?.toLowerCase() === 'india' ? '₹' : '$';
  
  return apiData.map((plan) => ({
    name: plan.name,
    label: plan.sub_title,
    price: `${currencySymbol}${plan.price}/month`,
    details: plan.is_current_plan,
    benefits: plan.plan_benefits,
    bg: plan.button_color || "white",
    color: plan.button_text_color || "black",
    actions: plan.button_text,
    isCurrent: plan.is_current_plan,
    id: plan.id,
    stroke_color: plan.stroke_color,
    show: plan?.disable_plan,
    payment_disclaimer: plan.payment_disclaimer,
  }));
}

const Card = ({
  name,
  price,
  details,
  benefits,
  actions,
  label,
  bg,
  color,
  id,
  stroke_color,
  show,
  payment_disclaimer = "",
}) => {
  // const handlePlanClick = async (planId) => {
  //   try {
  //     const profileData = JSON.parse(localStorage.getItem("profile"));

  //     if (!profileData?.UserId) {
  //       console.error("User profile data is missing or invalid.");
  //       return;
  //     }
  //     const response = await fetch(
  //       "https://us.uwc.world//new-uwc/uwc-expert/stripe/create-checkout-session",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "X-API-Key": "76d802e426a2cb28f3760c8c8f669983f67ed775",
  //           // If the session_id cookie is necessary for backend auth, add it manually like this:
  //           // 'Cookie' header is generally blocked by browsers for security — use credentials instead if needed.
  //         },
  //         body: JSON.stringify({
  //           uwc_user_id:`${profileData.UserId}`,
  //           env: "TEST",
  //           plan_id: `${planId}`,
  //         }),
  //         // You can optionally include credentials if cookie is required:
  //         // credentials: "include",
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error(`Failed to create checkout session: ${response.statusText}`);
  //     }

  //     const data = await response.json();

  //     if (data?.code === 200 && data?.data?.checkout_session) {
  //       window.open(data.data.checkout_session, "_blank");
  //     } else {
  //       console.error("Unexpected response:", data);
  //     }
  //   } catch (error) {
  //     console.error("Error updating plan:", error);
  //   }
  // };

  const handlePlanClick = async (planId) => {
    try {
      const profileData = JSON.parse(localStorage.getItem("profile"));

      if (!profileData?.UserId) {
        console.error("User profile data is missing or invalid.");
        return;
      }

      // /new-uwc/uwc-expert/stripe/create-billing-portal-session  -- This is the endpoint for creating a billing portal session (manage billing)
      // /new-uwc/uwc-expert/stripe/create-checkout-session -- This is the endpoint for creating a checkout session (buy a plan)
      const response = await axios.post(
        "https://us.uwc.world//new-uwc/uwc-expert/stripe/create-checkout-session",
        {
          uwc_user_id: `${profileData.UserId}`,
          // env: "TEST",
          uwc_plan_id: planId,
          url: window.location.href,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": "76d802e426a2cb28f3760c8c8f669983f67ed775",
            Accept: "application/json",
          },
          // If backend requires cookies for authentication:
          // withCredentials: true,
        }
      );

      const data = response.data;

      if (data?.code === 200 && data?.data?.checkout_session) {
        window.open(data.data.checkout_session, "_blank");
      } else {
        console.error("Unexpected response:", data);
      }
    } catch (error) {
      console.error("Error updating plan:", error);
    }
  };
  return (
    <div
      style={{
        boxShadow: "0px 10px 20px 0px rgba(12, 28, 68, 0.1)",
        border: "1px solid rgba(233, 230, 230, 1)",
      }}
      className="rounded-4 h-100"
    >
      <div className="d-flex flex-column justify-content-between h-100">
        <div>
          <div
            style={{
              background: bg,
              color: color,
              borderRadius: "10px 10px 0px 0px",
            }}
            className="p-3 border-bottom"
          >
            <p className="fs-4 m-0">{name}</p>
            <p style={{ fontSize: "14px" }} className="m-0 font-w500">
              {label}
            </p>
          </div>

          <h6 className="p-3 fs-5 m-0">{price}</h6>
          <ul
            style={{ minHeight: "150px" }}
            className="list-unstyled border-top p-3"
          >
            {benefits.map((benefit, index) => (
              <li key={index} className="my-1">
                {benefit.name}
              </li>
            ))}
          </ul>
        </div>
{payment_disclaimer && (
          <div className="p-3 text-muted" style={{ fontSize: "12px" }}>
            <p className="m-0">{payment_disclaimer}</p></div>)}
        <div className="p-3 d-flex justify-content-center">
          <button
            style={{
              background: bg,
              color: color,
              border: stroke_color ? `1px solid ${stroke_color}` : "none",
            }}
            className="rounded-pill w-100 p-2"
            onClick={() => handlePlanClick(id)}
          >
            {actions}
          </button>
        </div>
      </div>
    </div>
  );
};

export default function PlansBilling({ planslist }) {
  const { expertDetails } = useContext(AppContext);
  
  // const plans = mapApiPlansToUi(apiResponse);
  const [plans, setPlans] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [uiPlan, setUiPlan] = React.useState(null);
  const [usage, setUsage] = React.useState(null);
  const currentPlan = uiPlan?.find((p) => p.isCurrent);
  const fetchPlans = async () => {
    try {
      // Use context country data with fallback to localStorage
      const country = expertDetails?.profile?.country;
      let userId;
      
      // Try multiple sources for userId
      try {
        const profileData = JSON.parse(localStorage.getItem("profile"));
        userId = profileData?.UserId;
      } catch (e) {
        console.error("Error parsing profile data:", e);
        return;
      }

      if (!country || !userId) {
        console.error("Missing required data:", { 
          country, 
          userId, 
          expertDetailsLoaded: !!expertDetails?.profile 
        });
        return;
      }

      const response = await fetch(
        `https://us.uwc.world//new-uwc/subscription/plans/list?country=${encodeURIComponent(country)}&user_id=${userId}&platform=copilot`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": "76d802e426a2cb28f3760c8c8f669983f67ed775",
          },
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const resp = await response.json();
      if (resp.success) {
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  };
  React.useEffect(() => {
    if (planslist?.length > 0) {
      setPlans(planslist);
      setUiPlan(mapApiPlansToUi(planslist, expertDetails?.profile?.country));
    }
  }, [planslist, expertDetails?.profile?.country]);

  // Fetch plans when country data is available and no planslist provided
  React.useEffect(() => {
    if (!planslist?.length && expertDetails?.profile?.country && localStorage.getItem("profile")) {
      fetchPlans();
    }
  }, [expertDetails?.profile?.country, planslist?.length]);
  React.useEffect(() => {
    if (currentPlan) {
      getUsage();
    }
  }, [currentPlan]);
  const getUsage = async () => {
    try {
      const profileData = JSON.parse(localStorage.getItem("profile")); // Parse profileData if it's stored as a string

      const response = await fetch(
        `https://ws-stella.unitedwecare.com/api/v1/app/user/tracker/status/${profileData?.UserId}`,
        {
          headers: {
            accept: "application/json",
            Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiNzYzMiJ9.uv527OlLdX13f-ZRxmSBHwjxpK4QwC7Ob2ESYAST8R0`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const resp = await response.json();
      if (resp.success) {
        setUsage(resp.data);
      }
    } catch (error) {}
  };

  const handleManageClick = async () => {
    try {
      const profileData = JSON.parse(localStorage.getItem("profile"));

      if (!profileData?.UserId) {
        console.error("User profile data is missing or invalid.");
        return;
      }

      // /new-uwc/uwc-expert/stripe/create-billing-portal-session  -- This is the endpoint for creating a billing portal session (manage billing)
      // /new-uwc/uwc-expert/stripe/create-checkout-session -- This is the endpoint for creating a checkout session (buy a plan)
      const response = await axios.post(
        "https://us.uwc.world//new-uwc/uwc-expert/stripe/create-billing-portal-session",
        {
          uwc_user_id: `${profileData.UserId}`,
          // env: "TEST",
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": "76d802e426a2cb28f3760c8c8f669983f67ed775",
            Accept: "application/json",
          },
          // If backend requires cookies for authentication:
          // withCredentials: true,
        }
      );

      const data = response.data;

      if (data?.code === 200 && data?.data?.billing_portal_session) {
        window.open(data.data.billing_portal_session, "_blank");
      } else {
        console.error("Unexpected response:", data);
      }
    } catch (error) {
      console.error("Error updating plan:", error);
    }
  };

  return (
    <div className="container py-4">
      {/* Current Plan Summary */}

      {currentPlan && (
        <div>
          <div
            style={{
              boxShadow: "0px 10px 20px 0px rgba(12, 28, 68, 0.1)",
              border: "1px solid rgba(233, 230, 230, 1)",
            }}
            className="d-flex flex-column gap-2 rounded-4 p-4"
          >
            <h2 className="m-0">{currentPlan.name}</h2>
            <h5 className="d-flex align-items-center m-0 gap-2">
              {currentPlan.price}
              {currentPlan.details && (
                <span
                  style={{ fontSize: "12px" }}
                  className="text-muted bg-light px-2 py-1 rounded-pill"
                >
                  {currentPlan.details}
                </span>
              )}
            </h5>
            {/* Hide Review Billing Details if free plan */}
            {!currentPlan.price.includes("0/month") && (
              <p className="m-0" style={{ fontSize: "14px" }}>
                <span role="button" onClick={handleManageClick}>
                  Review Billing Details
                </span>{" "}
                {/* · <span>Upgrade</span> */}
              </p>
            )}
          </div>

          {/* Benefits List */}
          <h3 className="mt-5">Your Benefits</h3>
          {/* <div className="p-3">
            <div
              style={{       boxShadow: "0px 10px 20px 0px rgba(12, 28, 68, 0.1)",
                border: "1px solid rgba(233, 230, 230, 1)" }}
              className="row row-cols-lg-3 row-cols-md-2 row-cols-1 p-4 px-2 rounded-4"
            >
              {currentPlan.benefits.map((benefit, index) => (
                <p key={index} style={{ fontSize: "14px" }} className="my-1">
                  <ArrowCircleRightRounded /> {benefit}
                </p>
              ))}
            </div>
          </div> */}

          <div className="p-3">
            <div
              style={{
                boxShadow: "0px 10px 20px 0px rgba(12, 28, 68, 0.1)",
                border: "1px solid rgba(233, 230, 230, 1)",
              }}
              className="row row-cols-lg-3 row-cols-md-2 row-cols-1 p-4 px-2 rounded-4"
            >
              {currentPlan?.benefits
                .filter((b) => b.active)
                .map((benefit, index) => {
                  const benefitEnums = getBenefitEnums();
                  const key = Object.keys(benefitEnums).find(
                    (k) => benefitEnums[k] === benefit.benefit_type
                  );

                  const used = usage?.[key] ?? null; // Use null to differentiate from actual 0
                  const limit = benefit.usage_limit;
                  const percent =
                    limit > 0 && used !== null
                      ? Math.min(100, ((limit - used) / limit) * 100)
                      : null;

                  return (
                    <div key={index} className="mb-3">
                      <p
                        style={{ fontSize: "14px" }}
                        className="my-1 fw-semibold"
                      >
                        <ArrowCircleRightRounded
                          sx={{ color: "var(--primary-color)" }}
                          className="me-1"
                        />
                        {benefit.name}
                      </p>

                      {used === null ? null : limit === -1 ? (
                        <div
                          className="text-muted ms-4"
                          style={{ fontSize: "13px" }}
                        ></div>
                      ) : (
                        <div className="d-flex gap-2 ms-4 align-items-center">
                          <div
                            style={{
                              backgroundColor: "#e9ecef",
                              borderRadius: "10px",
                              height: "8px",
                              width: "100%",
                              overflow: "hidden",
                              maxWidth: "150px",
                            }}
                          >
                            <div
                              style={{
                                width: `${percent}%`,
                                backgroundColor: "var(--primary-color)",
                                height: "100%",
                              }}
                            />
                          </div>
                          <div
                            style={{ fontSize: "12px" }}
                            className="text-muted"
                          >
                            {limit - used} / {limit} used
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      )}

      {/* Other Plans */}
      <h3 className={currentPlan && "mt-5"}>
        Our {currentPlan && "Other"} Plans
      </h3>
      <div className="row g-4">
        {uiPlan
          ?.filter((plan) => !plan.isCurrent && !plan?.show)
          ?.map((plan, index) => (
            <div key={index} className="col-lg-4 col-md-6 col-12">
              <Card {...plan} />
            </div>
          ))}
      </div>
    </div>
  );
}
